import { CoreIcon } from '../core-icon';
import motoSideFillSVG from '../../assets/icons/moto-side-fill.svg';
import type { IconProps } from '../core-icon';

export const MotoSideFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={motoSideFillSVG} {...props} />;
};
